// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D2kA","placeholdersHeader":"styles_placeholdersHeader__jUhL3","editorStyle":"styles_editorStyle__8_ZQw","placeholdersBox":"styles_placeholdersBox__fdvPf"};